
document.addEventListener("DOMContentLoaded", () => {
  const btn = document.getElementById("scrollTopBtn");

  if (!btn) return;

  function toggleScrollTopButton() {
    const scrollTop = window.scrollY;
    const scrollableHeight =
      document.documentElement.scrollHeight - window.innerHeight;

    if (scrollableHeight <= 0) {
      btn.classList.remove("show");
      return;
    }

    const scrollPercentage =
      (scrollTop / scrollableHeight) * 100;

    btn.classList.toggle("show", scrollPercentage >= 20);
  }

  window.addEventListener("scroll", toggleScrollTopButton, {
    passive: true
  });

  toggleScrollTopButton();

  btn.addEventListener("click", (e) => {
    e.preventDefault();

    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  });
});
/*----------------Js for banner video size-----------------------*/
/*---------------- JS for banner video + resource animation -----------------------*/

document.addEventListener("DOMContentLoaded", () => {

    if (window.innerWidth <= 768) {
        return;
    }

    const hero = document.querySelector(
        ".section.section--page-width.color-custom-template--27674448331033__section_MNiwb8"
    );

    const collectionSection = document.querySelector(
        "#shopify-section-template--27674448331033__collection_list_tTyqhC"
    );

    if (!hero || !collectionSection) {
        console.log("Hero or collection not found");
        return;
    }

    /*
     * Get the actual resource-list section.
     */
    const resourceSection =
        collectionSection.querySelector(".section-resource-list");


    /*
     * IMPORTANT:
     * Never allow the resource section itself
     * to be translated.
     */
    if (resourceSection) {
        resourceSection.style.transform = "none";
        resourceSection.style.position = "relative";

        /*
         * Your theme is adding a very large
         * padding-block-start here.
         *
         * Change this to the gap you actually want.
         */
        resourceSection.style.paddingBlockStart = "20px";
    }


    const cards =
        collectionSection.querySelectorAll(".resource-list__item");

    if (cards.length < 3) {
        console.log("Collection items not found");
        return;
    }

    const left = cards[0];
    const middle = cards[1];
    const right = cards[2];


    /* --------------------------
       INITIAL STATE
    -------------------------- */

    [left, middle, right].forEach(card => {

        card.style.opacity = "0";

        card.style.willChange =
            "transform, opacity";

    });

    left.style.transform =
        "translateY(150px)";

    middle.style.transform =
        "translateY(120px) scale(.85)";

    right.style.transform =
        "translateY(150px)";


    /* --------------------------
       HERO
    -------------------------- */

    hero.style.transformOrigin =
        "center center";

    hero.style.position =
        "sticky";

    hero.style.top =
        "0";

    hero.style.zIndex =
        "0";

    hero.style.margin =
        "0 auto";

    hero.style.willChange =
        "transform, width";

    hero.style.transition =
        "none";


    const heroStartWidth =
        hero.getBoundingClientRect().width;


    /* --------------------------
       VIDEO HEIGHT
    -------------------------- */

    function getVideoHeight() {

        const videoWrapper =
            hero.querySelector(".custom-video-wrapper");

        if (videoWrapper) {

            const height =
                videoWrapper.getBoundingClientRect().height;

            if (height > 0) {
                return height;
            }
        }

        const video =
            hero.querySelector(".custom-video");

        if (video) {

            const height =
                video.getBoundingClientRect().height;

            if (height > 0) {
                return height;
            }
        }

        return window.innerHeight;
    }


    /* --------------------------
       SCROLL
    -------------------------- */

    function handleScroll() {

        if (window.innerWidth <= 768) {
            return;
        }

        const scrollTop =
            window.scrollY;

        const videoHeight =
            getVideoHeight();


        /*
         * Animation is based on
         * actual video height.
         */
        const progress =
            Math.min(
                Math.max(
                    scrollTop / videoHeight,
                    0
                ),
                1
            );


        const heroProgress =
            Math.min(
                progress / 0.6,
                1
            );


        /* --------------------------
           HERO WIDTH
        -------------------------- */

        const extraWidth = 120;

        const middleWidth =
            middle.getBoundingClientRect().width;

        const currentWidth =
            heroStartWidth +
            (
                (middleWidth + extraWidth) -
                heroStartWidth
            ) *
            heroProgress;

        hero.style.width =
            `${currentWidth}px`;


        /* --------------------------
           HERO POSITION
        -------------------------- */

        const heroRect =
            hero.getBoundingClientRect();

        const middleRect =
            middle.getBoundingClientRect();

        const heroCenterX =
            heroRect.left +
            heroRect.width / 2;

        const middleCenterX =
            middleRect.left +
            middleRect.width / 2;

        const translateX =
            (middleCenterX - heroCenterX) *
            heroProgress;


        hero.style.borderRadius =
            `${heroProgress * 30}px`;

        hero.style.transform =
            `translateX(${translateX}px)`;

        hero.style.zIndex =
            heroProgress > 0.9
                ? "1"
                : "0";


        /* --------------------------
           MIDDLE CARD
        -------------------------- */

        if (progress > 0.30) {

            let p =
                (progress - 0.30) / 0.30;

            p = Math.min(p, 1);

            middle.style.opacity = p;

            middle.style.transform =
                `translateY(${120 - 120 * p}px) scale(${0.85 + 0.15 * p})`;

        } else {

            middle.style.opacity = 0;

            middle.style.transform =
                "translateY(120px) scale(.85)";
        }


        /* --------------------------
           LEFT & RIGHT
        -------------------------- */

        if (progress > 0.60) {

            let p =
                (progress - 0.60) / 0.40;

            p = Math.min(p, 1);

            left.style.opacity = p;
            right.style.opacity = p;

            left.style.transform =
                `translateY(${150 - 150 * p}px)`;

            right.style.transform =
                `translateY(${150 - 150 * p}px)`;

        } else {

            left.style.opacity = 0;
            right.style.opacity = 0;

            left.style.transform =
                "translateY(150px)";

            right.style.transform =
                "translateY(150px)";
        }

    }


    /* --------------------------
       SCROLL
    -------------------------- */

    window.addEventListener(
        "scroll",
        handleScroll,
        {
            passive: true
        }
    );


    /* --------------------------
       RESIZE
    -------------------------- */

    window.addEventListener(
        "resize",
        () => {

            if (window.innerWidth <= 768) {
                return;
            }

            /*
             * Keep resource section
             * in normal document flow.
             */
            if (resourceSection) {
                resourceSection.style.transform = "none";
                resourceSection.style.paddingBlockStart = "20px";
            }

            handleScroll();

        },
        {
            passive: true
        }
    );


    /* --------------------------
       INITIAL
    -------------------------- */

    handleScroll();

});
/*------------------Jquery for menu----------*/

// Open submenu only when clicking the arrow
$('.menu-drawer').on('click', 'li.has-submenu > a', function (e) {

    e.preventDefault();
    e.stopPropagation();

    // Close any open submenu first
    $('.submenu-panel').removeClass('active');

    var $li = $(this).closest('.has-submenu');

    // Get the parent menu title
    var title = $li.children('a').find('.menu-drawer__menu-item-text').text().trim();

    $('.submenu-title').text(title);

    // Open only this submenu
    $li.children('.submenu-panel').addClass('active');

    $('.menu-drawer').addClass('submenu-open');

});
$('.submenu-back-header').on('click', function(){

    $('.submenu-panel').removeClass('active');

    $('.submenu-content').empty();

    $('.submenu-title').text('');

    $('.menu-drawer').removeClass('submenu-open');

});
$('.menu-drawer').on('click', '.submenu-arrow', function (e) {

    e.preventDefault();
    e.stopPropagation();

    $('.submenu-panel').removeClass('active');

    var $li = $(this).closest('.has-submenu');

    var title = $li.children('a').find('.menu-drawer__menu-item-text').text().trim();

    $('.submenu-title').text(title);

    $li.children('.submenu-panel').addClass('active');

    $('.menu-drawer').addClass('submenu-open');

});
$('.menu-drawer').on('click', '.menu-drawer__close-button', function () {

    $('.submenu-panel').removeClass('active');

    $('.submenu-title').text('');

    $('.menu-drawer').removeClass('submenu-open');

});
$('.submenu-content .menu-drawer__list-item').each(function () {
    if ($(this).find('img.menu-drawer__link-image').length > 0) {
        $(this).addClass('has-image');
    }
});

/*---------------------Video Banner-------------------Js-------------------------*/
function initCustomVideos() {

  const MUTE_ICON = "https://cdn.shopify.com/s/files/1/1014/3508/0985/files/Video_icon_1.svg?v=1788149436";
  const UNMUTE_ICON = "https://cdn.shopify.com/s/files/1/1014/3508/0985/files/Video_icon_3.svg?v=1788149483";

  const PLAY_ICON = "https://cdn.shopify.com/s/files/1/1014/3508/0985/files/Video_icon_a445d070-f66e-4a0d-b18a-49a2b07491b7.svg?v=1788149408";
  const PAUSE_ICON = "https://cdn.shopify.com/s/files/1/1014/3508/0985/files/Video_icon_2.svg?v=1788149481";

  document.querySelectorAll(".custom-video-wrapper").forEach(wrapper => {

    // Prevent duplicate initialization
    if (wrapper.dataset.videoInit) return;
    wrapper.dataset.videoInit = "true";

    const video = wrapper.querySelector(".custom-video");
    const playBtn = wrapper.querySelector(".video-play-btn");
    const muteBtn = wrapper.querySelector(".video-mute-btn");
    const muteIcon = wrapper.querySelector(".mute-icon");
    const heroContent = wrapper.querySelector(".hero-content");

    if (!video || !playBtn || !muteBtn || !muteIcon) return;

    // Play / Pause
    playBtn.addEventListener("click", () => {

      if (video.paused) {
        video.play();
      } else {
        video.pause();
      }

    });

    // Mute / Unmute
    muteBtn.addEventListener("click", () => {

      video.muted = !video.muted;

      muteIcon.src = video.muted
        ? MUTE_ICON
        : UNMUTE_ICON;

    });

    // Video playing
    video.addEventListener("play", () => {

      // Show pause image
      playBtn.innerHTML = `
        <img
          src="${PAUSE_ICON}"
          alt="Pause"
          class="video-control-icon video-pause-icon"
        >
      `;

      if (heroContent) {
        heroContent.classList.add("video-playing");
      }

    });

    // Video paused
    video.addEventListener("pause", () => {

      // Show play image
      playBtn.innerHTML = `
        <img
          src="${PLAY_ICON}"
          alt="Play"
          class="video-control-icon video-play-icon"
        >
      `;

      if (heroContent) {
        heroContent.classList.remove("video-playing");
      }

    });

  });
}

// Initial page load
document.addEventListener("DOMContentLoaded", initCustomVideos);

// Shopify Theme Editor
document.addEventListener("shopify:section:load", initCustomVideos);
/*---------- script for overlapped carousel-------------*/

document.addEventListener("DOMContentLoaded", function () {

    if (typeof Swiper === "undefined") return;

    new Swiper(".whySwiper", {
        loop: false,
          slidesPerView: 1.8,
    slidesPerGroup: 1,
    spaceBetween: 0,
    speed: 800,
     slidesOffsetAfter: 60,
    grabCursor: true,
      resistance: true,
    resistanceRatio: 0,

        breakpoints: {
            320: {
                slidesPerView: 1.2,
                slidesPerGroup: 1,
                slidesOffsetAfter:0
            },
            768: {
                slidesPerView: 1.2,
                slidesPerGroup: 1,
                slidesOffsetAfter:0
            },
            1024: {
                slidesPerView: 1.8,
                slidesPerGroup: 1
            },
            1400: {
                slidesPerView: 1.8,
                slidesPerGroup: 1
            }
        }
    });

});
/*document.addEventListener("DOMContentLoaded", function () {
 
    if (typeof Swiper === "undefined") return;
 
    new Swiper(".whySwiper", {

        loop: false,
     
        slidesPerView: 1.8,

        slidesPerGroup: 1,

        spaceBetween: 24,

        speed: 800,
        slidesOffsetAfter: 60,
 
        // Disable drag/swipe

        allowTouchMove: false,

        grabCursor: false,
 
        // Enable mouse wheel

        mousewheel: {

            enabled: true,

            forceToAxis: true,

            releaseOnEdges: true,

            sensitivity: 1,

        },
 
        breakpoints: {

            320: {

                slidesPerView: 1.2,

                slidesPerGroup: 1

            },

            768: {

                slidesPerView: 1.5,

                slidesPerGroup: 1

            },

            1024: {

                slidesPerView: 1.8,

                slidesPerGroup: 1

            },

            1400: {

                slidesPerView: 1.8,

                slidesPerGroup: 1

            }

        }

    });
 
});
 */

/*------------verticle single image slider-------------------*/
document.addEventListener("DOMContentLoaded", function () {

    const slider = document.querySelector(".verticalImageSlider");

    if (!slider) return;

    new Swiper(slider, {
        direction: "vertical",

        loop: true,

        slidesPerView: 1,

        spaceBetween: 0,

        allowTouchMove: true,

        speed: 5000,

        freeMode: {
            enabled: true,
            momentum: false,
            sticky: false
        },

        autoplay: {
            delay: 0,
            disableOnInteraction: false,
            pauseOnMouseEnter: false
        }
    });

});

/*---------------2 column layout for collection js---------------------*/

const grid = document.querySelector(".product-grid");

const isZoomOut =
  grid.getAttribute("product-grid-view") === "zoom-out";

const featuredItems = [...grid.querySelectorAll(".featured-grid-item")];
const normalItems = [...grid.querySelectorAll(".product-grid__item:not(.featured-grid-item)")];

if (isZoomOut) {
  featuredItems.forEach((item, index) => {
    const insertAfter = (index + 1) * 4;
    normalItems[insertAfter - 1]?.after(item);
  });
} else {
  featuredItems.forEach((item, index) => {
    const insertAfter = (index + 1) * 3;
    normalItems[insertAfter - 1]?.after(item);
  });
}
/*--------------Smooth scroll for move to top button-------------*/

/*-----------------Js for Product filter sticky------------*/
(function () {
  let facetsElement = null;
  let stickyStart = 0;

  function setupStickyFacets() {
    const element = document.querySelector(
      '.facets-block-wrapper.facets-block-wrapper--horizontal'
    );

    if (!element) return;

    // Don't recalculate if the same element is already being tracked
    if (element === facetsElement) return;

    facetsElement = element;

    // Get the element's original position in the document
    stickyStart = element.getBoundingClientRect().top + window.scrollY;

    checkSticky();
  }

  function checkSticky() {
    if (!facetsElement || !document.body.contains(facetsElement)) {
      setupStickyFacets();
      return;
    }

    if (window.scrollY >= stickyStart) {
      facetsElement.classList.add('is-sticky');
    } else {
      facetsElement.classList.remove('is-sticky');
    }
  }

  // Initial setup
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupStickyFacets);
  } else {
    setupStickyFacets();
  }

  // Check while scrolling
  window.addEventListener('scroll', checkSticky, { passive: true });

  // Important for Shopify AJAX/filter updates
  const observer = new MutationObserver(function () {
    setupStickyFacets();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();
/*------------end of sticky------------*/


